var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePlusGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_16188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.668 3V6.33333C11.668 6.55435 11.7558 6.76631 11.912 6.92259C12.0683 7.07887 12.2803 7.16667 12.5013 7.16667H15.8346",
    stroke: "#38CB89",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.168 18H5.83464C5.39261 18 4.96868 17.8244 4.65612 17.5118C4.34356 17.1993 4.16797 16.7754 4.16797 16.3333V4.66667C4.16797 4.22464 4.34356 3.80072 4.65612 3.48816C4.96868 3.17559 5.39261 3 5.83464 3H11.668L15.8346 7.16667V16.3333C15.8346 16.7754 15.659 17.1993 15.3465 17.5118C15.0339 17.8244 14.61 18 14.168 18Z",
    stroke: "#38CB89",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.66675V14.6667",
    stroke: "#38CB89",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.1667H12.5",
    stroke: "#38CB89",
    strokeWidth: 1.73077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_16188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlusGreen);
export default __webpack_public_path__ + "static/media/file-plus-green.a496520fe780763fa40f9e32e5bf28df.svg";
export { ForwardRef as ReactComponent };